import { ReactNode } from 'react';

import { DatetimeShow } from '@fhs/ui';

import {
  frenchDipUSEndDate,
  frenchDipUSStartDate,
  hotOnesEndDate,
  hotOnesStartDate,
} from '../constants';

export type LtoContentUSProps = {
  default?: ReactNode;
  frenchDip: ReactNode;
  ltoContent: ReactNode;
};

export const LtoContentUS = ({
  ltoContent,
  default: defaultContent,
  frenchDip,
}: LtoContentUSProps) => {
  return (
    <DatetimeShow
      after={hotOnesStartDate}
      before={hotOnesEndDate}
      default={
        <DatetimeShow
          after={frenchDipUSStartDate}
          before={frenchDipUSEndDate}
          default={defaultContent}
        >
          {frenchDip}
        </DatetimeShow>
      }
    >
      {ltoContent}
    </DatetimeShow>
  );
};
